/*
 * @Author: liuxiuting
 * @Date: 2022-11-21 10:38:46
 * @LastEditors: liuxiuting
 * @LastEditTime: 2026-04-09 10:20:57
 * @FilePath: \carrier\packages\common-mediax\src\apis\MediaCloudAdmin\SourceConfig.js
 * @Description:
 *
 * Copyright (c) 2025 by 用户/公司名, All Rights Reserved.
 */
import { createAPI } from '../../common'
// SourceConfig
export default {
  // 新增-来源
  postAddSource: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0tpvsdf', 'post', config),
  // 修改-来源
  putEditSource: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0tpvsdf', 'put', config),
  // 删除-来源
  deleteSource: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0tpvsdf', 'delete', config),
  // 查询-来源
  getSourceDetail: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0tpvsdf', 'get', config),
  // 草稿箱 - 保存至草稿箱
  postArticleDraft: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0esbgu', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 根据草稿id取得草稿详情
  getArticleDraftDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0esbgu', 'get', config),
  // 根据稿件id获取草稿列表 - 未使用
  getArticleDraftList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0epd0esbgu', 'get', config),
  // 根据稿件id获取草稿列表 - 当前用户下所有草稿
  getAllArticleDraftList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0esbgu0mjtu', 'get', config),
  // 根据稿件id获取稿件版本列表 - 当前稿件所有版本
  getArticleVersionsList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bsujdmf0wfstjpo0mjtu', 'get', config),
  // 根据版本id取得稿件版本详情
  getArticleVersionDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bsujdmf0wfstjpo0efubjm', 'get', config),
  // 获取签发发布详情
  getAssociations: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bttpdjbujpo0efubjm', 'get', config, {
      timeout: 90000
    }),

  // 获取签发流程记录
  getAssociationsRecords: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bttpdjbujpo0sfdpset', 'get', config, {
      timeout: 90000
    }),
  // 重复选用检查
  checkRepeat: (
    config,
    vconfig = {
      noHideLoading: true,
      timeout: 20000
    }
  ) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bttpdjbujpo0difdlSfqfbu', 'get', config, vconfig),
  // 批量查看稿件中是否有互动运营
  checkNis: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0difdlOjt', 'post', config),
  // 批量查看稿件中是否有互动运营, 视频音频，135样式等特殊样式（纸媒精选专用接口
  checkPaperSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0difdlQbqfsTfmfdu', 'post', config),
  // 设置供稿单位
  setArticleSourceCat: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0dbu', 'put', config),
  // 获取供稿单位
  getArticleSourceCat: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0tfbsdi', 'get', config),
  // 删除供稿单位
  deleteArticleSourceCat: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0dbu', 'delete', config),
  // 获取专家列表
  postExpertsList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0fyqfsut0mjtu', 'post', config)
}
